import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarService } from 'shared/common-services/src/lib/snack-bar-service/snackbar.service';

@Component({
  selector: 'lib-shared-snack-bar',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './shared-snack-bar.component.scss',
  templateUrl: './shared-snack-bar.component.html',
})
export class SharedSnackBarComponent {
  snackbar = inject(SnackbarService);

  isOpen() {
    return this.snackbar.isOpen();
  }

  message() {
    return this.snackbar.message();
  }

  dismissMills() {
    return this.snackbar.dismissMills();
  }

  position() {
    return this.snackbar.position();
  }

  handleOpenChange(event: Event) {
    const { detail }: CustomEvent = event as CustomEvent;
    if (!detail) this.snackbar.dismiss();
  }

  dismiss() {
    this.snackbar.dismiss();
  }
}
